import st from "./Project.module.css"
import {ReactComponent as Map} from "../../image/icons/project/map.svg";
import {ReactComponent as Home} from "../../image/icons/project/home.svg";
import {ReactComponent as Flat} from "../../image/icons/project/flat.svg";
import {ReactComponent as Area} from "../../image/icons/project/area.svg";
import {ReactComponent as LogoLetterK} from "../../image/icons/logoLetterK.svg";
import {MiniProject} from "../../components/UI/MiniProject/MiniProject";
import Slider from "../../components/Slider/Slider";
import {Link, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "../../axios";
import {ReactComponent as Arrow} from "../../image/icons/arrow-right.svg";
import ReactMarkdown from "react-markdown";
import ProjectSliderSkeleton from "../../components/UI/ProjectSkeleton/ProjectSliderSkeleton";

export const Project = () => {
    const id = useParams().id;

    const [load, setLoad] = useState(true);
    if (load) {
        setLoad(false)
    }

    const [projectInfo, setProjectInfo] = useState(false)
    const [otherProjectsInfo, setOtherProjectsInfo] = useState([])

    // этот проект мы получаем с сервера
    useEffect(() => {
        const controller = new AbortController();

        setProjectInfo(false)
        const fetchProject = async () => {
            const {data} = await axios.get(`/projects/${id}`, {
                // устанавливаем связь с контроллером
                signal: controller.signal
            });
            setProjectInfo(data);
        }
        const fetchOtherProjects = async () => {
            const {data} = await axios.get(`/projects/random`, {
                params: {
                    number: 3,
                    currentProjectId: id
                },
                // устанавливаем связь с контроллером
                signal: controller.signal
            });
            setOtherProjectsInfo(data);
        }

        fetchProject()
        fetchOtherProjects()

        return () => {
            controller.abort();
        };

    }, [id])

    return (
        <div className={st.fullContainer}>
            <div className={st.container}>
                <div className={st.navigation}>
                    <Link to={"/projects"}>Наши проекты</Link>
                    <Arrow/>
                    <span>{projectInfo?.name}</span>
                </div>
                <span className={st.projectName}>{projectInfo?.name}</span>
                {projectInfo ?
                    <Slider project={projectInfo}/>
                    :
                    <ProjectSliderSkeleton/>
                }


                <div className={st.projectInfoTags}>
                    <div className={st.tag}>
                        <Map className={st.icon}/>
                        <span>{projectInfo?.address}</span>
                    </div>
                    <div className={st.tag}>
                        <Home className={st.icon}/>
                        <span>{projectInfo?.place}</span>
                    </div>
                    <div className={st.tag}>
                        <Flat className={st.icon}/>
                        <span>{projectInfo?.numberOfRooms} комнаты</span>
                    </div>
                    <div className={st.tag}>
                        <Area className={st.icon}/>
                        <span>{projectInfo?.area} м²</span>
                    </div>
                </div>

                <div className={st.descriptionBlock}>
                    <LogoLetterK className={st.logoLetter}/>
                    {projectInfo?.description !== "" ?
                        <>
                            <span className={st.descTitle}>Описание</span>
                            <ReactMarkdown className={st.descText}>{projectInfo?.description}</ReactMarkdown>
                        </> : <></>
                    }
                    {/*<span className={st.descText}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci aliquam asperiores at beatae blanditiis consectetur consequuntur deserunt dicta doloremque ducimus ea enim esse et, harum impedit, in incidunt iste iusto laboriosam libero minima molestiae numquam odit perspiciatis placeat quaerat quisquam repudiandae soluta sunt unde ut velit vero voluptatibus. A ab accusamus asperiores assumenda cum cupiditate deserunt dignissimos, distinctio dolorum esse, facilis itaque labore libero maiores molestias nisi numquam optio quo repellat sapiente similique veritatis vero voluptas voluptate voluptatem! Accusamus, deserunt dignissimos ex fuga iste iusto nobis, non odit provident quae quaerat quas quasi rem repellat sed tenetur ut. Beatae, tempora? Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur dolorem eaque, modi natus porro quia quo reiciendis repellendus sunt temporibus. Ab distinctio doloribus expedita impedit ipsum molestias quo reiciendis veniam voluptatem voluptatibus! Accusantium ad animi, dolor dolore earum eius error, eveniet excepturi exercitationem explicabo fuga in nesciunt, nisi nulla odit quas quisquam similique ut voluptate voluptates. Alias amet architecto deleniti deserunt dicta, dolore earum ex id ipsam magnam, minus modi mollitia nesciunt nisi nulla perspiciatis quas quod rem repellat, rerum sint suscipit vero? Accusamus accusantium alias aliquid asperiores, assumenda atque aut consequatur delectus error eum id illo in maiores, minus nam nemo nesciunt odio optio pariatur qui repellat saepe soluta tempora temporibus veritatis vitae voluptatibus. Corporis deleniti dolore dolores enim necessitatibus neque vitae voluptatem! Amet at dignissimos et eum iste itaque iure necessitatibus repellat, reprehenderit vero! Aspernatur, autem deleniti distinctio et eveniet explicabo impedit nam recusandae rerum sint, ut veniam? Aperiam error itaque libero reiciendis suscipit. Accusantium blanditiis debitis delectus dolor eaque earum fuga itaque, modi necessitatibus nihil provident tempore vel. Ab alias asperiores, dicta dolor dolores est eum illum, laboriosam magni mollitia nam perferendis placeat quisquam recusandae sit velit voluptatum. Dicta dolore doloribus est exercitationem laboriosam quo sunt temporibus.</span>*/}
                </div>

                <div className={st.otherProjectsBlock}>
                    <span className={st.otherProjectsTitle}>Другие проекты</span>
                    <div className={st.otherProjects}>
                        {(otherProjectsInfo == null ? [...Array(3)] : otherProjectsInfo).map((project, id) =>
                            otherProjectsInfo == null ? (
                                <MiniProject isLoading={true} key={id}/>
                            ) : (
                                <MiniProject isLoading={false} project={project} key={project.id}/>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
        
    );
};

